<template>
  <v-app>
    <v-app-bar v-if="this.$vuetify.breakpoint.mdAndUp" color="black" height="72px" app flat>
      <v-btn plain @click="goHome" class="ml-11">
        <v-img max-height="56" max-width="56" src="./assets/logo.png"></v-img>
      </v-btn>
      <v-btn
        v-for="nav in navigations"
        :key="nav.text"
        plain
        :ripple="false"
        color="white"
        class="ml-6"
        @click="goTo(nav.goTo)"
        >{{ nav.text }}</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn color="white" plain :ripple="false" class="mr-11" @click="goTo('find-car')">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-app-bar>
    <v-app-bar v-else color="black" app flat dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-img max-height="30" max-width="30" src="./assets/logo.svg" @click="goHome"></v-img>
      <v-spacer></v-spacer>
      <v-btn text icon :ripple="false" @click="goTo('find-car')">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed dark color="black">
      <v-btn icon class="ma-3" @click="drawer = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-list>
        <v-divider class="mx-4"></v-divider>
        <div v-for="nav in navigations" :key="nav.text">
          <v-list-item @click="goTo(nav.goTo)">
            <v-list-item-content>
              <v-list-item-title>{{ nav.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mx-4"></v-divider>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <keep-alive>
        <router-view ref="routerView" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </v-main>

    <the-footer />
  </v-app>
</template>

<script>
import TheFooter from "./components/TheFoooter.vue"

export default {
  name: "App",
  components: { TheFooter },

  data() {
    return {
      drawer: false,
      navigations: [
        {
          text: "IN SHOP",
          goTo: "in-shop",
        },
        {
          text: "FIND US",
          goTo: "find-us",
        },
      ],
    }
  },

  methods: {
    goHome() {
      if (this.$router.currentRoute.name == "home") {
        this.$vuetify.goTo(0)
      } else {
        this.$router.push("/")
      }
    },
    async goTo(target) {
      this.drawer = false
      if (this.$router.currentRoute.name == "home") {
        this.$refs.routerView.scrollTo(target)
      } else {
        await this.$router.push("/")
        this.$refs.routerView.scrollTo(target)
      }
    },
  },
}
</script>
